/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
const TagManager = require('react-gtm-module')
const React = require('react')
const { HelmetProvider } = require('react-helmet-async')

exports.wrapRootElement = ({ element }) => {
  return React.createElement(HelmetProvider, null, element)
}

exports.onClientEntry = () => {
  if (typeof document !== 'undefined') {
    const TagManagerArgs = {
      gtmId: 'GTM-TF6VN34'
    }
    TagManager.initialize(TagManagerArgs)
  }
}
